// extracted by mini-css-extract-plugin
module.exports = {"header":"SearchTableHead_header__3ofdB","row":"SearchTableHead_row__2WRY7"};